module.exports = __webpack_public_path__ + "2c2bc675b2cf5afb60e37101c55962d2.MP3";